var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("coupon-send-config", {
    attrs: {
      id: _vm.id,
      "send-type": _vm.sendType,
      "allowed-events": [6],
      "default-event": 6,
      "event-fixed": true,
      "show-theme-tab": false,
    },
    on: { success: _vm.handleSuccess, cancel: _vm.handleCancel },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }